import React from 'react';
import ReactDOM from 'react-dom/client';
import 'izitoast/dist/css/iziToast.min.css';
import 'react-color-palette/css';
import 'sbx-crm-menu-ui/dist/index.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import packages from '../package.json';
import sbxInit from 'sbx-utils-lib/lib/properties';

//Call here
sbxInit();

console.log(packages.version);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
